module.exports = __webpack_public_path__ + "static/img/cwgl_p1.d32e153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/cwgl_p1.png
// module id = gSwT
// module chunks = 19